module.exports = __webpack_public_path__ + "static/media/trofeo2.0c60bb7e.png";